import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { type HedgeType as HedgeTypeTyping, POSSIBLE_HEDGE_TYPE } from '@/store/targetAccumulator/state.ts';

export const HedgeType = () => {
  const hedgeType = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.hedgeType);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleHedgeTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      sgwtWebAnalytics?.trackEvent(
        'Target Accumulator',
        'Hedge type changed',
        isDefined(event.target.value) ? event.target.value : 'cleared',
      );

      checkTargetAccumulatorWithTradeCapture({
        hedgeType: event.target.value as HedgeTypeTyping,
      });
    },
    [checkTargetAccumulatorWithTradeCapture, sgwtWebAnalytics],
  );

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.hedgeType">
      <Form.Select value={hedgeType} onChange={handleHedgeTypeChange} size="sm" data-e2e="hedge-selector">
        {POSSIBLE_HEDGE_TYPE.map((hedgeType) => (
          <option key={hedgeType} value={hedgeType}>
            <FormattedMessage id={`targetAccumulator.form.hedgeType.${hedgeType}`} />
          </option>
        ))}
      </Form.Select>
    </TargetAccumulatorFormField>
  );
};
